import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Gradpic from "../../image/cap-and-gown.jpg";
import { news } from "../../Data";
import { useParams, useNavigate } from "react-router-dom";

export default function NewsPage() {
  const navigate = useNavigate();
  const { title } = useParams();

  const currentIndex = news.findIndex((newsItem) => newsItem.title === title);
  const currentNews = news[currentIndex];

  // Find the previous and next news items (if they exist)
  const prevNews = currentIndex > 0 ? news[currentIndex - 1] : null;
  const nextNews =
    currentIndex < news.length - 1 ? news[currentIndex + 1] : null;

  const handleNavigate = (newsItem) => {
    if (newsItem) {
      navigate(`/news/${newsItem}`); // Navigate to the news page with title in the URL
    }
  };
  // If no news item is found, you might want to handle this case
  if (!currentNews) {
    return <div>News not found</div>;
  }
  return (
    <div>
      <Navbar />
      <main>
        {/* banner */}
        <div className="h-[136px] md:h-[300px] laptopSm:h-[344px] w-full">
          <img
            src={currentNews.image}
            alt=""
            className="w-full h-full object-cover object-center"
          />
        </div>

        <div className="responsive-padding">
          {/* Header */}
          <div className="py-10">
            <h1 className="font-montserrat font-bold text-xl md:text-2xl laptopSm:text-3xl tracking-[0.04em] text-primary-normal text-center">
              {currentNews.title}
            </h1>
            <h6 className="font-Nunito text-xs md:text-sm laptopSm:text-base leading-7 tracking-[0.04em] pt-2 text-center">
              {currentNews.date}
            </h6>
          </div>
          {/* content */}
          <div className="font-Nunito text-xs md:text-sm laptopSm:text-base leading-7 tracking-[0.04em] text-primary-normal flex flex-col gap-4">
            {currentNews.content.map((paragraph) => (
              <p
                key={paragraph.id}
                dangerouslySetInnerHTML={{ __html: paragraph.text }}
              />
            ))}
          </div>

          {/* footer */}
          <div className="flex flex-col md:flex-row gap-y-4 justify-between my-8 py-6 relative before:absolute before:w-full before:h-[0.5px] before:rounded-lg before:bg-grey-lighActive before:top-0">
            <div>
              {prevNews && (
                <div className="flex gap-4 items-center group">
                  <svg
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-[#1C1B1F] group-hover:text-text-normal"
                  >
                    <path
                      d="M3.05381 5.99945L7.65381 1.39945L6.60006 0.345703L0.946308 5.99945L6.60006 11.6532L7.65381 10.5995L3.05381 5.99945Z"
                      fill="currentColor"
                    />
                  </svg>
                  <div className="flex group-hover:underline group-hover:text-text-normal text-primary-normal">
                    <span
                      className="font-Nunito text-xs md:text-sm laptopSm:text-base font-medium leading-2 tracking-[0.04em] cursor-pointer"
                      onClick={() => handleNavigate(prevNews.title)}
                    >
                      Prev:&nbsp;
                    </span>
                    <span
                      className="font-Nunito text-xs md:text-sm laptopSm:text-base font-medium leading-2 tracking-[0.04em] cursor-pointer  "
                      onClick={() => handleNavigate(prevNews.title)}
                    >
                      {prevNews.title}
                    </span>
                  </div>
                </div>
              )}
            </div>

            {nextNews && (
              <div
                onClick={() => handleNavigate(nextNews.title)}
                className="flex gap-4 justify-end items-center cursor-pointer group" // Add group class here
              >
                <div className="flex hover:underline text-text-normal">
                  <span className="font-Nunito text-xs md:text-sm laptopSm:text-base font-medium leading-2 tracking-[0.04em] text-text-normal">
                    Next:&nbsp;
                  </span>
                  <span className="font-Nunito text-xs md:text-sm laptopSm:text-base font-medium leading-2 tracking-[0.04em] text-text-normal">
                    {nextNews.title}
                  </span>
                </div>
                <svg
                  width="8"
                  height="12"
                  viewBox="0 0 8 12"
                  xmlns="http://www.w3.org/2000/svg"
                  className="group-hover:text-text-normal fill-text-normal" // Apply the fill change on hover here
                >
                  <path
                    d="M4.94619 5.99945L0.346191 1.39945L1.39994 0.345703L7.05369 5.99945L1.39994 11.6532L0.346191 10.5995L4.94619 5.99945Z"
                    fill="currentColor" // Make sure fill is currentColor for dynamic fill change
                  />
                </svg>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
